import React, { useState, useEffect } from 'react';
import { Card, Container, Row, Col, Spinner, Table, Image } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faUserCircle } from '@fortawesome/free-solid-svg-icons';
import { useNavigate, useParams } from 'react-router';
import ExamService from '../../../../services/exam.service';
import toast from 'react-hot-toast';

export default function Counselling() {
    const navigate = useNavigate();
    const { invigilatorId } = useParams();
    const [users, setUsers] = useState<any>();
    const [loading, setLoading] = useState(true);

    const getReverificationUser = async () => {
        setLoading(true);
        try {
            const res = await ExamService.getReverificationData(invigilatorId);
            if (res.status === 200) {
                setUsers(res.data.data.operator);
            }
        } catch (err: any) {
            toast.error(
                err?.response?.data?.message ||
                err?.response?.data ||
                "Failed to fetch users"
            );
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (invigilatorId) {
            getReverificationUser();
        }
    }, [invigilatorId]);

    return (
        <Container className="py-4">
            <h3 className="mb-4">
                <FontAwesomeIcon
                    icon={faChevronLeft}
                    className="me-2"
                    size='sm'
                    onClick={() => navigate(-1)}
                />
                Verification Users
            </h3>

            {loading ? (
                <div className="text-center">
                    <Spinner animation="border" variant="primary" />
                    <p className="mt-3">Loading counselling users...</p>
                </div>
            ) : (
                <>
                    <Row className="mb-4">
                        <Col xs={12} md={6} style={{ backgroundColor: '#f8f9fa' }} className='p-3 rounded'>
                            <Card.Title>{users?.userName}</Card.Title>
                            <Card.Subtitle className="mb-2 text-muted">{users?.emailId}</Card.Subtitle>
                            <p className="text-muted small mb-0">
                                Access: {new Date(users?.accessStartTime).toLocaleDateString()} - {new Date(users?.accessEndTime).toLocaleDateString()}
                            </p>
                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            <h5 className="mb-3">Assigned Students</h5>
                            {users?.studentsAssigned && users.studentsAssigned.length > 0 ? (
                                <Table striped bordered hover responsive className="shadow-sm">
                                    <thead className="table-dark">
                                        <tr>
                                            <th>#</th>
                                            <th>Avatar</th>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th>Roll Number</th>
                                            <th>Center ID</th>
                                            <th>Center Name</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {users.studentsAssigned.map((student: any, index: number) => (
                                            <tr key={student._id}>
                                                <td>{index + 1}</td>
                                                <td>
                                                    <Image
                                                        src={student.avatar}
                                                        alt={student.name}
                                                        roundedCircle
                                                        width={40}
                                                        height={40}
                                                        onError={(e: any) => {
                                                            e.target.src = 'https://via.placeholder.com/40';
                                                        }}
                                                    />
                                                </td>
                                                <td>{student?.name}</td>
                                                <td>{student?.email}</td>
                                                <td>{student?.rollNo}</td>
                                                <td>{student?.allocatedCenterId}</td>
                                                <td>{student?.centerPreference}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            ) : (
                                <div className="text-muted">No students assigned</div>
                            )}
                        </Col>
                    </Row>
                </>
            )}
        </Container>
    );
}
